'use client'

import React from 'react'
import HeaderAppRouter from '../Header'
import Footer from '../Footer'
import {Box, Button, Container, Grid, Paper, Typography} from '@mui/material'
import useTranslation from '../../util/translations/useTranslation'
import Link from 'next/link'
import {ROUTE_CONTACT, ROUTE_HOME} from '../../Routes'
import Head from 'next/head'

interface ErrorContentProps {
    error: Error & {digest?: string};
    reset: () => void;
}

const ErrorContent = ({error, reset}: ErrorContentProps) => {
    const {getT} = useTranslation()

    // Create a wrapper function for translations with fallbacks for missing keys
    const getTranslation = (key: string, fallback: string) => {
        const translation = getT(key)
        // If translation is missing (returns the key), use the fallback
        return translation === key ? fallback : translation
    }

    return (
        <>
            <Head>
                <title>Fehler aufgetreten | First Class Performance</title>
                <meta name='robots' content='noindex, nofollow' />
            </Head>
            <HeaderAppRouter />
            <Container>
                <Box sx={{my: 8}}>
                    <Grid container spacing={4} alignItems='center' justifyContent='center'>
                        <Grid
                            size={{
                                xs: 12,
                                md: 8,
                            }}>
                            <Paper elevation={0} sx={{p: 4, backgroundColor: 'transparent'}}>
                                <Typography variant='h1' component='h1' gutterBottom>
                                    {getTranslation('error.title', 'Ein Fehler ist aufgetreten')}
                                </Typography>
                                <Typography variant='body1' paragraph>
                                    {getTranslation('error.message', 'Leider ist bei der Verarbeitung Ihrer Anfrage ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kehren Sie zur Startseite zurück.')}
                                </Typography>
                                <Typography variant='body2' color='text.secondary' paragraph>
                                    {error.message || 'Ein unbekannter Fehler ist aufgetreten.'}
                                </Typography>
                                <Box mt={4} display='flex' justifyContent='flex-start' gap={2}>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        onClick={() => reset()}
                                    >
                                        {getTranslation('error.tryAgain', 'Erneut versuchen')}
                                    </Button>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        component={Link}
                                        href={ROUTE_HOME}
                                    >
                                        {getTranslation('error.backToHome', 'Zurück zur Startseite')}
                                    </Button>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        component={Link}
                                        href={ROUTE_CONTACT}
                                    >
                                        {getTranslation('error.contactUs', 'Kontaktieren Sie uns')}
                                    </Button>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <Footer />
        </>
    );
}

export default ErrorContent
